<main class="main-home-secton">
  <div class="bg">
    <div class="container">
      <div class="about">
        <div class="row">
          <div class="col-lg-12">
            <div class="CSR_banner text-center">
              <div>
                <img
                  src="assets/images/CSR_logo.png"
                  alt=""
                  class="img-fluid"
                />
              </div>
              <h2 class="m-3">Catalyzing Growth, Crafting Legacies!</h2>
              <p class="mb-4">
                StartupTN CSR Spot is a single window for connecting Corporates
                with impactful CSR focused projects of Tamil Nadu Incubators,
                promoting Innovation centric CSR expenditure in the state
              </p>
              <div class="btn-margin">
                <button class="Partner-btn" (click)="partnerregister()">
                  Partner with StartupTN for CSR
                </button>
                <button class="corprate-btn">Download Quick Guide</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- csr Section -->
  <section class="csr-incubator">
    <div class="container">
      <h2 class="csr-incubator-title text-center">
        <span>CSR</span> for Incubator - UnTapped Growth Potential
      </h2>
      <div class="box">
        <div class="incubator-box line-box">
          <div class="head-img">
            <img src="assets/images/24-img.png" alt="" class="img-fluid" />
          </div>
          <div class="text-center center-img">
            <img src="assets/images/selfcare 1.png" alt="" class="img-fluid" />
          </div>

          <p class="mt-2">
            24% of Corporates are unaware that<b> Incubators are qualified </b
            >for CSR Funding
          </p>
        </div>
        <div class="incubator-box line-box">
          <div class="head-img">
            <img src="assets/images/45-img.png" alt="" class="img-fluid" />
          </div>
          <div class="text-center center-img">
            <img
              src="assets/images/no-idea (1) 1.png"
              alt=""
              class="img-fluid"
            />
          </div>
          <p class="mt-2">
            45% of Corporates funding Incubators are unaware of available
            <b>CSR funding options</b> to Incubators
          </p>
        </div>
        <div class="incubator-box">
          <div class="head-img">
            <img src="assets/images/0.2-img.png" alt="" class="img-fluid" />
          </div>
          <div class="text-center center-img">
            <img
              src="assets/images/startup-business (1) 1.png"
              alt=""
              class="img-fluid"
            />
          </div>
          <p class="mt-2">
            Only 0.2% of total CSR Expenditure is allocated for
            <b>Innovation centric</b> activities
          </p>
        </div>
      </div>
    </div>
  </section>

  <section class="CSR-activity">
    <div class="container">
      <h2>
        Are you looking forward to a Trusted Partner for your CSR Activities?
      </h2>
      <p class="mt-2">
        Being a Responsible Corporate, you can accelerate Innovation through
        Incubators in the following ways
      </p>

      <div class="row">
        <div class="col-lg-6">
          <div class="activity-box">
            <div>
              <img
                src="assets/images/activity-1.png"
                alt=""
                class="img-fluid"
              />
            </div>
            <h3 class="ml-4">
              Contribution to the creation of Innovation Infrastructure
            </h3>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="activity-box">
            <div>
              <img
                src="assets/images/activity-2.png"
                alt=""
                class="img-fluid"
              />
            </div>
            <h3 class="ml-4">⁠Research and Development Contribution</h3>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="activity-box">
            <div>
              <img
                src="assets/images/activity-3.png"
                alt=""
                class="img-fluid"
              />
            </div>
            <h3 class="ml-4">Startup Support Funding through Incubators</h3>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="activity-box">
            <div>
              <img
                src="assets/images/activity-4.png"
                alt=""
                class="img-fluid"
              />
            </div>
            <h3 class="ml-4">Creation of workspaces and makerspaces</h3>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="activity-box">
            <div>
              <img
                src="assets/images/activity-5.png"
                alt=""
                class="img-fluid res-img"
              />
            </div>
            <h3 class="ml-4">⁠Impact driven cohorts</h3>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="activity-box">
            <div>
              <img
                src="assets/images/activity-6.png"
                alt=""
                class="img-fluid res-img"
              />
            </div>
            <h3 class="ml-4">⁠Innovation Literacy and more</h3>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="think_csr">
    <div class="container-fluid">
      <div class="title">
        <h2 class="text-center think">
          Think <span class="gra">CSR</span> Think
          <span style="color: #253b80"> StartupTN </span>
        </h2>
      </div>

      <div class="marquee">
        <div class="marquee-content">
          <div class="marquee-item">
            <div class="entry">
              <div class="num">
                <span>1</span>
              </div>
              <div class="text-center">
                <img
                  src="assets/images/think_csr_1.png"
                  alt=""
                  class="img-fluid"
                />
              </div>
              <h5 class="mt-4 text-center">Nurturing Innovation and Growth</h5>
            </div>
          </div>

          <div class="marquee-item">
            <div class="entry">
              <div class="num">
                <span>2</span>
              </div>
              <div class="text-center">
                <img
                  src="assets/images/think_csr_2.png"
                  alt=""
                  class="img-fluid"
                />
              </div>
              <h5 class="mt-4 text-center">Positive Brand Image</h5>
            </div>
          </div>

          <div class="marquee-item">
            <div class="entry">
              <div class="num">
                <span>3</span>
              </div>
              <div class="text-center">
                <img
                  src="assets/images/think_csr_3.png"
                  alt=""
                  class="img-fluid"
                />
              </div>
              <h5 class="mt-4 text-center">Talent Attraction and Retention</h5>
            </div>
          </div>

          <div class="marquee-item">
            <div class="entry">
              <div class="num">
                <span>4</span>
              </div>
              <div class="text-center">
                <img
                  src="assets/images/think_csr_4.png"
                  alt=""
                  class="img-fluid"
                />
              </div>
              <h5 class="mt-4 text-center">Addressing Social Challenges</h5>
            </div>
          </div>

          <div class="marquee-item">
            <div class="entry">
              <div class="num">
                <span>5</span>
              </div>
              <div class="text-center">
                <img
                  src="assets/images/think_csr_5.png"
                  alt=""
                  class="img-fluid"
                />
              </div>
              <h5 class="mt-4 text-center">Long-Term Sustainability</h5>
            </div>
          </div>

          <div class="marquee-item">
            <div class="entry">
              <div class="num">
                <span>6</span>
              </div>
              <div class="text-center">
                <img
                  src="assets/images/think_csr_6.png"
                  alt=""
                  class="img-fluid"
                />
              </div>
              <h5 class="mt-4 text-center">Inclusive Economic Development</h5>
            </div>
          </div>

          <div class="marquee-item">
            <div class="entry">
              <div class="num">
                <span>7</span>
              </div>
              <div class="text-center">
                <img
                  src="assets/images/think_csr_7.png"
                  alt=""
                  class="img-fluid"
                />
              </div>
              <h5 class="mt-4 text-center">Local Community Engagement</h5>
            </div>
          </div>
          <div class="marquee-item"></div>
          <div class="marquee-item"></div>

          <div class="marquee-item">
            <div class="entry">
              <div class="num">
                <span>1</span>
              </div>
              <div class="text-center">
                <img
                  src="assets/images/think_csr_1.png"
                  alt=""
                  class="img-fluid"
                />
              </div>
              <h5 class="mt-4 text-center">Nurturing Innovation and Growth</h5>
            </div>
          </div>

          <div class="marquee-item">
            <div class="entry">
              <div class="num">
                <span>2</span>
              </div>
              <div class="text-center">
                <img
                  src="assets/images/think_csr_2.png"
                  alt=""
                  class="img-fluid"
                />
              </div>
              <h5 class="mt-4 text-center">Positive Brand Image</h5>
            </div>
          </div>

          <div class="marquee-item">
            <div class="entry">
              <div class="num">
                <span>3</span>
              </div>
              <div class="text-center">
                <img
                  src="assets/images/think_csr_3.png"
                  alt=""
                  class="img-fluid"
                />
              </div>
              <h5 class="mt-4 text-center">Talent Attraction and Retention</h5>
            </div>
          </div>

          <div class="marquee-item">
            <div class="entry">
              <div class="num">
                <span>4</span>
              </div>
              <div class="text-center">
                <img
                  src="assets/images/think_csr_4.png"
                  alt=""
                  class="img-fluid"
                />
              </div>
              <h5 class="mt-4 text-center">Addressing Social Challenges</h5>
            </div>
          </div>

          <div class="marquee-item">
            <div class="entry">
              <div class="num">
                <span>5</span>
              </div>
              <div class="text-center">
                <img
                  src="assets/images/think_csr_5.png"
                  alt=""
                  class="img-fluid"
                />
              </div>
              <h5 class="mt-4 text-center">Long-Term Sustainability</h5>
            </div>
          </div>

          <div class="marquee-item">
            <div class="entry">
              <div class="num">
                <span>6</span>
              </div>
              <div class="text-center">
                <img
                  src="assets/images/think_csr_6.png"
                  alt=""
                  class="img-fluid"
                />
              </div>
              <h5 class="mt-4 text-center">Inclusive Economic Development</h5>
            </div>
          </div>

          <div class="marquee-item">
            <div class="entry">
              <div class="num">
                <span>7</span>
              </div>
              <div class="text-center">
                <img
                  src="assets/images/think_csr_7.png"
                  alt=""
                  class="img-fluid"
                />
              </div>
              <h5 class="mt-4 text-center">Local Community Engagement</h5>
            </div>
          </div>
          <div class="marquee-item"></div>
          <div class="marquee-item"></div>
        </div>
      </div>
    </div>
  </section>
  <section class="Mandate-bg">
    <div class="Mandate-title">
      <h2>CSR Mandate in India for Incubators</h2>
    </div>
    <div class="mandate-img">
      <img src="assets/images/mandate-img.png" alt="" class="img-fluid" />
    </div>
  </section>
</main>
<app-footer></app-footer>
